import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { ComProductDealerModel } from 'src/app/model/com-product-dealer.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductDealerService } from 'src/oldApp/services/com-product-dealer.service';
import { CreatorService } from 'src/app/services/creator.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { ModalScProductDealerComponent } from 'src/oldApp/shared/modal-sc-product-dealer/modal-sc-product-dealer.component';

@Component({
  selector: 'app-sc-product-dealer',
  templateUrl: './sc-product-dealer.component.html',
  styleUrls: ['./sc-product-dealer.component.css']
})
export class ScProductDealerComponent implements OnInit {
  // estado pagina
  public page:string='ScCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public dealers:ComProductDealerModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public productCOECatalog:HMGenericCatalog[]=[];
  public paymentTypeCatalog:CatalogModel[]=[];
  public dealerCatalog:CatalogModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private productDealerService:ComProductDealerService,
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private vwCommissionConfiguatorService:VwCommissionConfiguratorService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //

  //
  add=()=> {
    let dealer=this.creator.newComProductDealerModel();
    let modalRef=this.modalService.open(ModalScProductDealerComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.dealer=dealer;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(dealer:ComProductDealerModel)=> {
    let modalRef=this.modalService.open(ModalScProductDealerComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.dealer={...dealer};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;
  product=item=> this.productCOECatalog.find(pro=> pro.idCatalogType===item.productosCOEId).description;
  dealer=item=> this.dealerCatalog.find(dealer=> dealer.id===item.dealerId)?this.dealerCatalog.find(dealer=> dealer.id===item.dealerId).description:'NO ENCONTRADO!';
  payment=item=> this.paymentTypeCatalog.find(pay=> pay.id===item.paymentId).description;

  // INFO
  getCatalogs=()=> {
      forkJoin(
        this.productDealerService.getAll(),
        this.catEmployeeJobService.getAll(),
        this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
        this.vwCommissionConfiguatorService.getPayments(),
        this.vwCommissionConfiguatorService.getAfiliates()
      )
      .pipe(
        tap(([dealerResp, empJobResp, prodResp, payResp, dealResp]:[any, any, any, any, any])=> {
          if(dealerResp && empJobResp && prodResp && payResp && dealResp) {
            this.dealers=dealerResp.data;
            this.employeeJobCatalog=empJobResp.data;
            this.productCOECatalog=prodResp.data;
            this.paymentTypeCatalog=payResp.data;
            this.dealerCatalog=dealResp.data;
            this.viewStatus=1;
          }
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
        })
      )
      .subscribe();
  }
}
